/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Tag_EyebrowInputs */

const en_directory_taxonomy_index_tag_eyebrow = /** @type {(inputs: Directory_Taxonomy_Index_Tag_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product topics`)
};

const zh_directory_taxonomy_index_tag_eyebrow = /** @type {(inputs: Directory_Taxonomy_Index_Tag_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品主题`)
};

/**
* | output |
* | --- |
* | "Product topics" |
*
* @param {Directory_Taxonomy_Index_Tag_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_tag_eyebrow = /** @type {((inputs?: Directory_Taxonomy_Index_Tag_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Tag_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_tag_eyebrow(inputs)
	return zh_directory_taxonomy_index_tag_eyebrow(inputs)
});
export { directory_taxonomy_index_tag_eyebrow as "directory.taxonomy_index.tag.eyebrow" }